import React from 'react';
import { Link } from 'react-router-dom';
import { Building, Settings, Star, ArrowRight } from 'lucide-react';
import { useData } from '../../context/DataContext';

const AdminDashboard = () => {
  const { projects, featuredProjectIds, siteSettings } = useData();

  const bitenCount = projects.filter((p) => p.status === 'Biten').length;
  const devamCount = projects.filter((p) => p.status === 'Devam Eden').length;

  return (
    <div>
      <h1 className="text-2xl font-bold text-white mb-8">Dashboard</h1>

      {/* Stats */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        <div className="p-6 bg-anthracite-light rounded-lg border border-gold/10">
          <Building className="w-8 h-8 text-gold mb-4" />
          <p className="text-3xl font-bold text-white">{projects.length}</p>
          <p className="text-gray-400 text-sm">Toplam Proje</p>
        </div>
        <div className="p-6 bg-anthracite-light rounded-lg border border-gold/10">
          <div className="w-8 h-8 bg-green-500/20 rounded-full flex items-center justify-center mb-4">
            <span className="text-green-400 font-bold">✓</span>
          </div>
          <p className="text-3xl font-bold text-white">{bitenCount}</p>
          <p className="text-gray-400 text-sm">Biten Proje</p>
        </div>
        <div className="p-6 bg-anthracite-light rounded-lg border border-gold/10">
          <div className="w-8 h-8 bg-gold/20 rounded-full flex items-center justify-center mb-4">
            <span className="text-gold font-bold">▶</span>
          </div>
          <p className="text-3xl font-bold text-white">{devamCount}</p>
          <p className="text-gray-400 text-sm">Devam Eden Proje</p>
        </div>
        <div className="p-6 bg-anthracite-light rounded-lg border border-gold/10">
          <Star className="w-8 h-8 text-gold mb-4" />
          <p className="text-3xl font-bold text-white">{featuredProjectIds.length}</p>
          <p className="text-gray-400 text-sm">Öne Çıkan Proje</p>
        </div>
      </div>

      {/* Quick Links */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <Link
          to="/admin/projeler"
          className="p-6 bg-anthracite-light rounded-lg border border-gold/10 hover:border-gold/30 transition-all duration-300 group"
        >
          <Building className="w-8 h-8 text-gold mb-4" />
          <h3 className="text-lg font-semibold text-white mb-2">Projeleri Yönet</h3>
          <p className="text-gray-400 text-sm mb-4">
            Proje ekle, düzenle veya sil
          </p>
          <div className="flex items-center text-gold text-sm group-hover:translate-x-2 transition-transform duration-300">
            <span>Git</span>
            <ArrowRight className="w-4 h-4 ml-2" />
          </div>
        </Link>

        <Link
          to="/admin/one-cikan"
          className="p-6 bg-anthracite-light rounded-lg border border-gold/10 hover:border-gold/30 transition-all duration-300 group"
        >
          <Star className="w-8 h-8 text-gold mb-4" />
          <h3 className="text-lg font-semibold text-white mb-2">Öne Çıkan Projeler</h3>
          <p className="text-gray-400 text-sm mb-4">
            Anasayfada gösterilecek 5 projeyi seç
          </p>
          <div className="flex items-center text-gold text-sm group-hover:translate-x-2 transition-transform duration-300">
            <span>Git</span>
            <ArrowRight className="w-4 h-4 ml-2" />
          </div>
        </Link>

        <Link
          to="/admin/ayarlar"
          className="p-6 bg-anthracite-light rounded-lg border border-gold/10 hover:border-gold/30 transition-all duration-300 group"
        >
          <Settings className="w-8 h-8 text-gold mb-4" />
          <h3 className="text-lg font-semibold text-white mb-2">Site Ayarları</h3>
          <p className="text-gray-400 text-sm mb-4">
            İletişim bilgileri ve WhatsApp ayarları
          </p>
          <div className="flex items-center text-gold text-sm group-hover:translate-x-2 transition-transform duration-300">
            <span>Git</span>
            <ArrowRight className="w-4 h-4 ml-2" />
          </div>
        </Link>
      </div>

      {/* Site Info */}
      <div className="mt-8 p-6 bg-anthracite-light rounded-lg border border-gold/10">
        <h3 className="text-lg font-semibold text-white mb-4">Site Bilgileri</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <p className="text-gray-400 text-sm">WhatsApp Numarası</p>
            <p className="text-white">{siteSettings?.whatsappNumber}</p>
          </div>
          <div>
            <p className="text-gray-400 text-sm">E-posta</p>
            <p className="text-white">{siteSettings?.email}</p>
          </div>
          <div>
            <p className="text-gray-400 text-sm">Telefon 1</p>
            <p className="text-white">{siteSettings?.phone1}</p>
          </div>
          <div>
            <p className="text-gray-400 text-sm">Telefon 2</p>
            <p className="text-white">{siteSettings?.phone2}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;